'use client'

// src/constants/aldana-slug.ts
var ALDANA_SLUG = "al-dana";

export {
  ALDANA_SLUG
};
//# sourceMappingURL=chunk-OMQ4LRG6.mjs.map